import { makeFieldSchema, FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const DisclaimerTextFieldSchema = makeFieldSchema({
  output: z => z.string(),
  uiOptions: z =>
    z.object({
      title: z.string().describe('Title for the disclaimer').optional(),
      message: z.string().describe('Message for the disclaimer').optional(),
      objectLabel: z.string().describe('Label for the checkbox').optional(),
    }),
});

export type DisclaimerTextUiOptions =
  typeof DisclaimerTextFieldSchema.schema.uiOptions;

export type DisclaimerTextComponentProps = FieldExtensionComponentProps<boolean, DisclaimerTextUiOptions>;

export const DisclaimerTextSchema = DisclaimerTextFieldSchema.schema;
